import React from 'react'

import mouse from './../../UI/animation/Mouse_clic.svg'

interface Props {
  openScene: boolean,
  showDrag: boolean,
  isPortrait: boolean
}

interface State {
  showDragAnimation: boolean
}

class Drag extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showDragAnimation: true
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.openScene !== this.props.openScene && this.props.openScene){
      setTimeout(() => {
        this.setState({
          showDragAnimation: true
        })
      }, 9000)
    }
  }
  
  render(): React.ReactNode {
      return(
        <div className={`drag-animation-container ${(this.state.showDragAnimation && this.props.openScene && this.props.showDrag) ? 'fade-in':'fade-out'} ${this.props.isPortrait ? 'drag-animation-container-portrait':''}`}>
          <div className='drag-animation-container-main'>
            <img src={mouse} alt='' className='mouse mouse-move'/>
            <div className='drag-animation-text'>Arrastra el cursor para rotar 360°</div>
          </div>
          <div className='drag-hr'></div>
          <div className='drag-animation-container-main'>
            <div className="scroll-downs">
              <div className="mousey">
                <div className="scroller"></div>
              </div>
            </div>
            <div className='drag-animation-text'>Usa scroll para acercar o alejar el modelo</div>
          </div>
        </div>
      )
  }
}

export default Drag